module.exports = __webpack_public_path__ + "static/media/Icon_12.ea76f35f.svg";